import Constant from '@/common/constant/Constant';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import Utils from '@/common/utils/utils';
import { cloneDeep, isEqual } from 'lodash';
import {
    getListProductManagement,
    updateProductManagement
} from '@/service/productManagementService';
import { findNameDuplicate, sortListProductByOrderDesc } from './ProductListHandler';
import MessageCode from '@/common/constant/MessageCode';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

export const getListEditionData = async (
    API,
    setEditionList,
    setIsLoading,
    setEditionListDefault,
    productId,
    setOpenDropDownVersion,
    openDropDownVersionData,
    setNameProduct,
    setNameProductDefault,
    setOrderItem
) => {
    setIsLoading(true);
    let requestBody = {
        type: ProductManagementConstant.METHOD_PRODUCT.GET_LIST_EDITION,
        productId: productId
    };
    let res = await getListProductManagement(API, requestBody);
    if (!res.status) {
        setIsLoading(false);
        return;
    }
    let listEdition = Utils.convertJSONDataToObject(res.listEdition ? res.listEdition : []);
    setOrderItem(listEdition.length);

    listEdition = listEdition.filter(edition => !edition.deletedAt)
    listEdition = listEdition.map(edition => {
        return ({
        ...edition,
        listVersion: Utils.convertJSONDataToObject(edition.listVersion),
        name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, edition.name),
        defaultStatus: edition.status,
        modeEditing: false
    })});

    let openDropDownVersion = listEdition.map(edition => {
        let element = {
            id: edition.id,
            open: false
        };
        let editionData = openDropDownVersionData.find(item => item.id === edition.id);
        if (editionData) {
            element.open = editionData.open;
        }
        return element;
    });

    if (openDropDownVersionData) {
        setOpenDropDownVersion(openDropDownVersion);
    }

    listEdition = sortListProductByOrderDesc(listEdition);
    let listEditonClone = cloneDeep(listEdition);

    let productDetail = Utils.convertJSONDataToObject(res.productDetail ? res.productDetail : {});
    let productInfo = {
        id: productDetail.id,
        name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, productDetail.name),
        error: ''
    };

    setNameProduct({...productInfo});
    setNameProductDefault({...productInfo});

    setEditionList(listEdition);
    setEditionListDefault(listEditonClone);
    
    setIsLoading(false);
};

export const isDisabledButtonSubmit = (
    hasError,
    listEdition,
    isEdit,
    editionListDefault,
    listVersionUpdated,
    nameProduct,
    nameProductDefault
) => {
    if (
        isEqual(listEdition, editionListDefault) &&
        Utils.isEmptyArray(listVersionUpdated) &&
        isEqual(nameProduct, nameProductDefault)
    )
        return true;
    if (!isEdit) return true;

    let newLineEditions = listEdition.filter(edition => edition?.createNewLine === true);
    let isRequired = newLineEditions.some(
        edition => Utils.isEmptyString(edition.name) || !edition.name.trim()
    );
    if (isRequired) return true;

    if (hasError) return true;
    return false;
};

export const onSubmitData = async (
    API,
    editionList,
    setEditionList,
    setIsLoading,
    setTriggerReload,
    userId,
    setIsEdit,
    enqueueSnackbar,
    setHasError,
    productId,
    nameProduct,
    setIsShowPopUpReload,
    listVersionUpdated,
    setNameProduct,
    setListVersionUpdated
) => {
    setIsLoading(true);
    let editionListClone = cloneDeep(editionList);
    let listEditionFilter = editionListClone.filter(
        edition =>
            edition.isPositionChanged ||
            edition.createNewLine ||
            edition.isUpdatedName ||
            edition.isUpdatedStatus ||
            edition.isUpdatedTrial ||
            edition.isDeleted
    );

    listEditionFilter = listEditionFilter.map(item => {
        delete item.error;
        delete item.updatedAt;
        delete item.listVersion;
        return item;
    });

    let requestBody = {
        userId: userId,
        listEdition: JSON.stringify(listEditionFilter),
        type: ProductManagementConstant.METHOD_PRODUCT.CREATE_AND_UPDATE_EDITION_LIST,
        productId: productId,
        nameProduct: nameProduct?.name,
        listVersionUpdated: JSON.stringify(listVersionUpdated)
    };

    let res = await updateProductManagement(API, requestBody);

    if (!res?.status) {
        if (res.errorMessage === 'COMMSG030' || res.errorMessage === MessageCode.RELOAD_PRODUCT_LIST_DELETED) {
            setIsLoading(false);
            setIsShowPopUpReload({isOpen: true, message: res.errorMessage});
            return;
        }

        if(res.errorMessage === 'MSG-CM-DATA-DUPLICATION') {
            setNameProduct(prevState => {
                return {
                    ...prevState,
                    error: 'MSG-CM-DATA-DUPLICATION'
                };
            });
        }

        let listEditionErrors = Utils.convertJSONDataToObject(res?.listEditionErrors);
            
        if(!Utils.isEmptyArray(listEditionErrors)) {
            listEditionErrors = listEditionErrors?.map(item => item.id);
            editionList = editionList?.map(item => {
                if (listEditionErrors.includes(item.id)) {
                    item.error = 'MSG-CM-DATA-DUPLICATION-EDITION';
                    item.modeEditing = true;
                }
                return item;
            });
            setEditionList(editionList);
        }
        
        setHasError(true);
        setIsLoading(false);
        return;
    }
    //reset state
    setIsEdit(false);
    setHasError(false);
    setListVersionUpdated([]);

    setTriggerReload(Date.now().toString());    

    enqueueSnackbar(buildSnackbarMessage('MSG-CM-UPDATE-DATA-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
};

export const onClickYesCancel = async (
    API,
    editionList,
    setEditionList,
    setIsLoading,
    setTriggerReload,
    userId,
    setIsEdit,
    enqueueSnackbar,
    setHasError,
    setIsShowPopUpCancel,
    hasError,
    isEdit,
    productId,
    setIsClosePanelProduct,
    nameProduct,
    setIsShowPopUpReload,
    listVersionUpdated,
    setNameProduct,
    setListVersionUpdated
) => {
    if (hasError) {
        setIsClosePanelProduct &&
            setIsClosePanelProduct({
                isClose: false,
                componentType: ProductManagementConstant.EDITION_LIST
            });
        setIsShowPopUpCancel(false);
        return;
    }
    let newLineEditions = editionList.filter(edition => edition?.createNewLine === true);

    let isRequired = newLineEditions.some(
        edition => Utils.isEmptyString(edition.name) || !edition.name.trim()
    );
    if (isRequired) {
        let editionListClone = cloneDeep(editionList);
        editionListClone.forEach(edition => {
            if (
                edition?.createNewLine &&
                (Utils.isEmptyString(edition.name) || !edition.name.trim())
            ) {
                edition.error = 'COMM01MSG11';
            }
        });
        setEditionList(editionListClone);
        setIsClosePanelProduct &&
            setIsClosePanelProduct({
                isClose: false,
                componentType: ProductManagementConstant.EDITION_LIST
            });
        return setIsShowPopUpCancel(false);
    }

    setIsClosePanelProduct &&
        setIsClosePanelProduct({
            isClose: false,
            componentType: ProductManagementConstant.EDITION_LIST
        });
    setIsShowPopUpCancel(false);
    await onSubmitData(
        API,
        editionList,
        setEditionList,
        setIsLoading,
        setTriggerReload,
        userId,
        setIsEdit,
        enqueueSnackbar,
        setHasError,
        productId,
        nameProduct,
        setIsShowPopUpReload,
        listVersionUpdated,
        setNameProduct,
        setListVersionUpdated
    );
};

export const onCancelResetData = (
    setIsShowPopUpCancel,
    onOpenComponentName
) => {
    setIsShowPopUpCancel(false);
    onOpenComponentName({}, ProductManagementConstant.PRODUCT_LIST)
};

export const onClickToggleDropDownVersion = (editionId, setOpenDropDownVersion, listVersion) => {
    if (isEmptyListVersion(listVersion)) return;
    setOpenDropDownVersion(prevState => {
        let clonePrevState = prevState.map(item => {
            if (item.id === editionId) {
                item.open = !item.open;
                return item;
            }
            return item;
        });

        return clonePrevState;
    });
};

export const checkOpenDropDownVerson = (editionId, openDropDownVersion) => {
    let edtionInfo = openDropDownVersion?.find(item => item.id === editionId);
    return edtionInfo?.open ? edtionInfo?.open : false;
};

export const isEmptyListVersion = listVersionData => {
    let listData = Utils.convertJSONDataToObject(listVersionData);
    return Utils.isEmptyArray(listData);
};

export const onClickCancelEdit = (setIsShowPopUpCancel, isEdit, onOpenComponentName) => {
    if (isEdit) {
        setIsShowPopUpCancel(true);
        return;
    }
    return onOpenComponentName({}, ProductManagementConstant.PRODUCT_LIST);
};

export const onClickDeleteEditionItem = (
    setEditionList,
    index,
    setIsEdit,
    setIsShowPopUpDelete
) => {
    setIsEdit(true);
    setIsShowPopUpDelete(false);
    setEditionList(prevState => {
        const newInputs = [...prevState];
        newInputs[index] = {
            ...newInputs[index],
            isDeleted: true
        };
        return newInputs;
    });
};

export const handleChangeProductName = (e, setNameProduct, setHasError, setIsEdit) => {
    let value = e.target.value;

    setHasError(false);
    setIsEdit(true);
    setNameProduct(prevState => {

        if (Utils.isEmptyString(value) || !value.trim()) {
            //validate required
            prevState = { ...prevState, name: value, error: 'COMM01MSG11' };
            setHasError(true);
            return prevState;
        } 
        else if(value?.length > ProductManagementConstant.MAX_LENGTH_NAME) {
            prevState = { ...prevState, name: value, error: 'COMMSG022' };
            setHasError(true);
            return prevState;
        }
        return {
            ...prevState,
            name: value,
            error: ''
        };
    });
};

export const handleBlurProductName = (e, setNameProduct, setHasError) => {
    setNameProduct(prevState => {
        if (Utils.isEmptyString(prevState.name) || !prevState.name.trim()) {
            prevState = { ...prevState, error: 'COMM01MSG11' };
            setHasError(true);
            return prevState;
        }
        if(prevState.name?.length > ProductManagementConstant.MAX_LENGTH_NAME) {
            prevState = { ...prevState, error: 'COMMSG022' };
            setHasError(true);
        }
        return prevState;
    });
};

export const onEditModeEdition = (editionId, setEditionList, handleClose) => {
    handleClose();
    setEditionList(prevState => {
        let newInputs = [...prevState];
        let index = Utils.findIndexInArrayById(editionId, newInputs);
        if (index !== -1) {
            newInputs[index] = { ...newInputs[index], modeEditing: !newInputs[index].modeEditing };
        }
        return newInputs;
    });
};

export const onChangeValue = (e, setEditionList, indexEdition, setHasError, setIsEdit) => {
    let value = e.target.value;

    setIsEdit(true);
    setEditionList(prevState => {
        const newInputs = [...prevState];
        newInputs[indexEdition] = {
            ...newInputs[indexEdition],
            name: value,
            error: '',
            isUpdatedName: true
        };

        if (Utils.isEmptyString(value) || !value.trim()) {
            //validate required
            newInputs[indexEdition] = { ...newInputs[indexEdition], error: 'COMM01MSG11' };
            setHasError(true);
            return newInputs;
        } 
        else if(value?.length > ProductManagementConstant.MAX_LENGTH_NAME) {
            newInputs[indexEdition] = { ...newInputs[indexEdition], error: 'COMMSG022' };
            setHasError(true);
            return newInputs;
        }

        let nameDuplicate = findNameDuplicate(newInputs);

        setHasError(false);
        newInputs.forEach((item, i) => {
            if (
                !nameDuplicate.includes(item.name.trim()) &&
                item?.error === 'MSG-CM-DATA-DUPLICATION-EDITION'
            ) {
                newInputs[i] = { ...newInputs[i], error: '' };
            }
        });
        return newInputs;
    });
};

export const handleInputBlur = (setEditionList, indexEdition, setHasError) => {
    setEditionList(prevState => {
        const newInputs = [...prevState];
        if (
            Utils.isEmptyString(newInputs[indexEdition].name) ||
            !newInputs[indexEdition].name.trim()
        ) {
            //validate required
            newInputs[indexEdition] = { ...newInputs[indexEdition], error: 'COMM01MSG11' };
            setHasError(true);
        } 
        else if(newInputs[indexEdition].name?.length > ProductManagementConstant.MAX_LENGTH_NAME) {
            newInputs[indexEdition] = { ...newInputs[indexEdition], error: 'COMMSG022' };
            setHasError(true);
        }
        else {
            // Kiểm tra trùng lặp trong các trường name
            const isDuplicate = newInputs.some(
                (input, i) => i !== indexEdition && input.name === newInputs[indexEdition].name?.trim()
            );

            if (isDuplicate) {
                newInputs[indexEdition].error = 'MSG-CM-DATA-DUPLICATION-EDITION';
                setHasError(true);
            } else {
                // clear error
                newInputs[indexEdition] = { ...newInputs[indexEdition], error: '' };
                const hasError = newInputs.some(input => input.error);
                setHasError(hasError);
            }
        }
        return newInputs;
    });
};

export const onClickChangeStatus = (setEditionList, index, value, currentValue, handleClose, setIsEdit) => {
    if (value === currentValue) {
        handleClose();
        return;
    }
    setIsEdit(true);

    setEditionList(prevState => {
        const newInputs = [...prevState];
        if(value === ProductManagementConstant.STATUS.INACTIVE) {
            newInputs[index].isTrial = false;
            newInputs[index].isUpdatedTrial = true;
        }
        newInputs[index] = {
            ...newInputs[index],
            status: value,
            isUpdatedStatus: true
        };
        return newInputs;
    });
    handleClose();
};

export const onClickChangeStatusVersion = (
    setListVersionUpdated,
    index,
    listVersion,
    setListVersion,
    handleCloseActionVersion,
    value,
    currentValue,
    setIsEdit,
    setEditionList
) => {
    if (value === currentValue) {
        handleCloseActionVersion();
        return;
    }
    setIsEdit(true);

    setListVersion(prevState => {
        const newInputs = [...prevState];
        let editionId = newInputs[index]?.editionId;

        if(value === ProductManagementConstant.STATUS.ON_SALES) {
            let indexCurrentOnsales = newInputs.findIndex((item, i) => {
                return item.status === ProductManagementConstant.STATUS.ON_SALES;
            });

            if(indexCurrentOnsales !== -1) {
                newInputs[indexCurrentOnsales] = {
                    ...newInputs[indexCurrentOnsales],
                    status: ProductManagementConstant.STATUS.INACTIVE,
                };

                setListVersionUpdated(prevVersionUpdated => {
                    let newInputsUpdated = [...prevVersionUpdated];
                    let idUpdated = newInputs[indexCurrentOnsales]?.id;
                    let indexUpdated = Utils.findIndexInArrayById(idUpdated, newInputsUpdated);
                    if (indexUpdated === -1) {
                        let dataUpdated = {
                            id: idUpdated,
                            editionId:  newInputs[indexCurrentOnsales]?.editionId,
                            status: ProductManagementConstant.STATUS.INACTIVE,
                            defaultStatus: newInputs[indexCurrentOnsales]?.status,
                            isUpdatedStatus: true
                        };
                        newInputsUpdated = [...newInputsUpdated, dataUpdated];
                    }
                    else {
                        newInputsUpdated[indexUpdated] = {
                            ...newInputsUpdated[indexUpdated],
                            status: ProductManagementConstant.STATUS.INACTIVE
                        };
                    }
            
                    return newInputsUpdated;
                });
            };

            
        }
        newInputs[index] = {
            ...newInputs[index],
            status: value
        };

        setListVersionUpdated(prevVersionUpdated => {
            let newInputsUpdated = [...prevVersionUpdated];
            let id = newInputs[index]?.id;
            let indexUpdated = Utils.findIndexInArrayById(id, newInputsUpdated);
    
            if (indexUpdated === -1) {
                let dataUpdated = {
                    id: id,
                    editionId: editionId,
                    status: value,
                    defaultStatus: newInputs[index]?.status,
                    isUpdatedStatus: true
                };
                newInputsUpdated = [...newInputsUpdated, dataUpdated];
            }
            else {
                newInputsUpdated[indexUpdated] = {
                    ...newInputsUpdated[indexUpdated],
                    status: value
                };
            }
    
            return newInputsUpdated;
        });

        if(!hasStatusOnSales(newInputs)) {
            setEditionList(prevEdition => {
                let newEditions = [...prevEdition];
                let indexEdition = Utils.findIndexInArrayById(editionId, newEditions);

                if(indexEdition !== -1) {
                    newEditions[indexEdition] = {
                        ...newEditions[indexEdition],
                        status: ProductManagementConstant.STATUS.INACTIVE,
                        isTrial: false,
                        isUpdatedStatus: true,
                        isUpdatedTrial: true
                    }
                }
                return newEditions;
            })
        }

        return newInputs;
    });

    handleCloseActionVersion();
};

export const onDeletedVersionItem = (
    setListVersionUpdated,
    index,
    listVersion,
    setListVersion,
    setIsEdit,
    setShowPopUpDelete,
    setEditionList
) => {
    setIsEdit(true);

    setListVersion(prevState => {
        const newInputs = [...prevState];
        let editionId = newInputs[index]?.editionId;

        newInputs[index] = {
            ...newInputs[index],
            status: ProductManagementConstant.STATUS.INACTIVE,
            isDeleted: true
        };

        setListVersionUpdated(prevVersionUpdated => {
            let newInputsUpdated = [...prevVersionUpdated];
            let id = newInputs[index]?.id;
            let indexUpdated = Utils.findIndexInArrayById(id, newInputsUpdated);
    
            if (indexUpdated === -1) {
                let dataUpdated = {
                    id: id,
                    editionId: editionId,
                    defaultStatus: newInputs[index]?.status,
                    isDeleted: true
                };
                newInputsUpdated = [...newInputsUpdated, dataUpdated];
            } else {
                newInputsUpdated[indexUpdated] = {
                    ...newInputsUpdated[indexUpdated],
                    isDeleted: true
                };
            }
            return newInputsUpdated;
        });

        if(!hasStatusOnSales(newInputs)) {
            setEditionList(prevEdition => {
                let newEditions = [...prevEdition];
                let indexEdition = Utils.findIndexInArrayById(editionId, newEditions);

                if(indexEdition !== -1) {
                    newEditions[indexEdition] = {
                        ...newEditions[indexEdition],
                        status: ProductManagementConstant.STATUS.INACTIVE,
                        isTrial: false,
                        isUpdatedStatus: true,
                        isUpdatedTrial: true
                    }
                }
                return newEditions;
            })
        }
        
        return newInputs;
    });

    setShowPopUpDelete({ isOpen: false })
};

export const hasStatusOnSales = (array) => {
    if(Utils.isEmptyArray(array)) return false;
    return array.some(item => item?.status === ProductManagementConstant.STATUS.ON_SALES);
}

export const onReloadPage = (
    onOpenComponentName,
    isShowPopUpReload,
    setTriggerReload,
    setIsShowPopUpReload,
    setIsEdit,
    setHasError,
    setListVersionUpdated
) => {
    setIsShowPopUpReload({isOpen: false, message: ''});
    if (isShowPopUpReload.message === MessageCode.RELOAD_PRODUCT_LIST_DELETED) {
        return onOpenComponentName({}, ProductManagementConstant.PRODUCT_LIST);
    }

    //reset state
    setIsEdit(false);
    setHasError(false);
    setListVersionUpdated([]);
    setTriggerReload(Date.now().toString());
};